import { FES_API } from "@apis/common";
import { VehicleDataRequest } from "@product-pages/model/types";

export const saveVehicleData = (data: VehicleDataRequest) => {
  return FES_API.post(`/transactions`, data).then((response) => {
    return response.data;
  });
};